import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { JhiEventManager } from '../../shared/core-utils';
import { LotService } from '../../shared/inventory/service/lot.service';
import { Lot } from '../../shared/inventory/model/lot.model';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-lot-detail',
    templateUrl: './lot-detail.component.html'
})
export class LotDetailComponent implements OnInit, OnDestroy {

    lot: Lot;
    subscriptionsManager = new SubscriptionsManager();

    constructor(
        private eventManager: JhiEventManager,
        private lotService: LotService,
        private route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.subscriptionsManager.add = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInLots();
    }

    load(id) {
        this.subscriptionsManager.add = this.lotService.find(id)
            .subscribe((lotResponse: HttpResponse<Lot>) => {
                this.lot = lotResponse.body;
            });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscriptionsManager.unsubscribeAll();
    }

    registerChangeInLots() {
        this.subscriptionsManager.add = this.eventManager.subscribe(
            'lotListModification',
            (response) => this.load(this.lot.id)
        );
    }
}
